import { decode } from "./flexiblePolyline";

export const getLocation = (): Promise<{ lat: number; lon: number }> => {
  return new Promise((resolve) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            lat: position.coords.latitude,
            lon: position.coords.longitude,
          });
        },
        () => {
          resolve({
            lat: -23.5475,
            lon: -46.63611,
          });
        }
      );
    }
  });
};

export const renderLocation = (item?: string, isString = true) => {
    if (!item) {
      return '';
    }
    const d = decode(item);
    const lastIndex = d.polyline[d.polyline.length - 1];

    return isString ? `${lastIndex[0]}, ${lastIndex[1]}` : lastIndex;
  }